import nengi from 'nengi'
import { uuid } from '../../utils/primitive-types'

class ApplyAugmentsToWeaponCommand {
	static protocol = {
		augmentIds: { type: nengi.String, indexType: nengi.UInt16 },
		weaponId: nengi.String,
	}
	augmentIds: uuid[]
	weaponId: uuid
	/**
	 * Creates an instance of AttachAugmentToWeaponCommand.
	 * @param {uuid} augmentId Augment ID
	 * @param {uuid} weaponId Weapon ID or empty string to use the current weapon
	 * @memberof AttachAugmentToWeaponCommand
	 */
	constructor(augmentIds: uuid[], weaponId: uuid) {
		this.augmentIds = augmentIds
		this.weaponId = weaponId
	}
}

export default ApplyAugmentsToWeaponCommand
